module.exports = __webpack_public_path__ + "img/home_tk_s_icon_1.f16b6f0.png";